import useFirestore from "./useFirestore";

let cachedUid: string | null = null;
let cachedBranchId: string | null = null;

/**
 * 현재 로그인 사용자의 branch_id 반환
 *
 * - 강사(Teacher): User/Auth/Teacher/{uid}.branch_id
 * - 지점장(Branch): Teacher 문서 없음 → uid 자체가 branch_id
 * - 세션 동안 결과를 캐시해 반복 Firestore 조회 방지
 */
const useGetBranchId = () => {
    const {readFirestoreOneDoc} = useFirestore();

    const getBranchId = async() => {
        const uid = sessionStorage.getItem("uid") || "";
        if (cachedUid === uid && cachedBranchId) {
            return cachedBranchId;
        }

        const branch_id = await readFirestoreOneDoc("User/Auth/Teacher", uid).then(res => {
            if(res.exists()){
                return res.data().branch_id as string;
            }
            return uid;
        });

        cachedUid = uid;
        cachedBranchId = branch_id;
        return branch_id;
    }

    return {getBranchId};
}

export default useGetBranchId;
